export enum DashboardView {
  CONVERSATIONS,
  CALENDAR,
  SETTINGS_PROFILE,
  SETTINGS_SETTINGS,
  SETTINGS_BILLING,
  SETTINGS_USERS,
  SETTINGS_ADVISER_GROUPS,
  SETTINGS_ADVISER_STATUSES,
  SETTINGS_ADVISER_AVATAR,
  SETTINGS_ASSIGNMENT_RULES,
  SETTINGS_MANUAL_ASSIGNMENT,
  SETTINGS_BOTS,
  SETTINGS_PROACTIVE_MESSAGES,
  SETTINGS_TAGGING,
  SETTINGS_TAGS,
  SETTINGS_TAG_GROUPS,
  SETTINGS_WIDGET_CONFIG,
  SETTINGS_WORKING_HOURS,
  SETTINGS_MESSAGES,
  SETTINGS_WEBHOOKS,
  SETTINGS_REPORTS,
  SETTINGS_ROLES,
  AI_SETTINGS_GENERAL,
  AI_SETTINGS_MODEL_CONFIGURATION,
  AI_SETTINGS_TESTING,
  REPORTS_EFFICIENCY,
  REPORTS_SERVICE_LEVEL_TAG_GROUPS,
  REPORTS_SERVICE_LEVEL_TAGS,
  REPORTS_BACK_LINE_TAGS,
  REPORTS_ADVISER_GROUPS,
  REPORTS_ADVISER_TAG_GROUPS,
  REPORTS_OTHER,
}
